/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import _size from 'lodash/size';

const editRegex = /\[.+\]\[(.+)\] (.+)/;

const oneOffCredits = (
  {
    id,
    type,
    userId,
    identityId,
    amount,
    productId,
    productName,
    voided,
    reason,
    comment,
    currentBalance,
    createdAt,
    updatedAt,
  },
  { username, creation = false } = {}
) => {
  if (creation) {
    reason = `[${username}][${reason}] ${comment}`;
    return {
      identityId: identityId.trim(),
      amount,
      reason,
    };
  }

  const matches = reason.match(editRegex);
  if (reason && _size(matches) === 3) {
    reason = matches[1];
    comment = matches[2];
  }

  return {
    id,
    type,
    userId,
    productId,
    productName,
    voided,
    reason,
    comment,
    currentBalance,
    createdAt,
    updatedAt,
  };
};

export default oneOffCredits;
